import api from "./api";

export const getsPais = async () => {
    const response = await api.get("/UbigeoView/GetPaises");
    return response.data.data;
};

export const getsDepartamentosByIdPais = async (idPais) => {
    const response = await api.get("/UbigeoView/GetDepartamentosByIdPais?idPais=" + idPais);
    return response.data.data;
};

export const getsProvinciasByIdDepartamento = async (idDepartamento) => {
    const response = await api.get("/UbigeoView/GetProvinciasByIdDepartamento?idDepartamento=" + idDepartamento);
    return response.data.data;
};

export const getsUbigeosByIdProvincia = async (idProvincia) => {
    const response = await api.get("/UbigeoView/GetUbigeosByIdProvincia?idProvincia=" + idProvincia);
    return response.data.data;
};

// Aliases usados por la nueva pagina de navegabilidad.
export const getPaises = getsPais;
export const getDepartamentos = getsDepartamentosByIdPais;
export const getProvincias = getsProvinciasByIdDepartamento;
export const getUbigeos = getsUbigeosByIdProvincia;

// ---------------------------------------------------------------------------
// Busqueda unificada de Ubigeo con cancelacion (AbortController)
// ---------------------------------------------------------------------------
export const buscarUbigeos = async (texto, signal, limite = 20) => {
    if (!texto || texto.trim().length < 3) return [];
    const response = await api.get(
        `/UbigeoView/Buscar?texto=${encodeURIComponent(texto.trim())}&limite=${limite}`,
        { signal }
    );
    return response.data?.data || [];
};

export const getUbigeoById = async (idUbigeo, signal) => {
    if (!idUbigeo || idUbigeo <= 0) return null;
    const response = await api.get(`/UbigeoView/GetUbigeoViewById?idUbigeo=${idUbigeo}`, { signal });
    return response.data?.data || null;
};

export const getUbigeoByCodigo = async (codigo, signal) => {
    if (!codigo) return null;
    const response = await api.get(`/UbigeoView/GetByCodigo?codigo=${encodeURIComponent(codigo)}`, { signal });
    return response.data?.data || null;
};

// ---------------------------------------------------------------------------
// Mantenimiento: listado y escrituras de paises, departamentos, provincias y
// ubigeos. La lista plana trae todas las entidades, aunque no tengan hijos.
// ---------------------------------------------------------------------------
export const getsMantenimientoView = async (filters) => {
    const params = new URLSearchParams();
    params.append("pais", filters?.pais ?? "");
    params.append("departamento", filters?.departamento ?? "");
    params.append("provincia", filters?.provincia ?? "");
    params.append("ubigeo", filters?.ubigeo ?? "");
    params.append("nivel", filters?.nivel ?? 0);
    params.append("limite", filters?.limite ?? 0);

    const response = await api.get("/UbigeoView/GetsMantenimientoView?" + params.toString());
    return response.data.data;
};

export const addUpdatePais = async (dto) => {
    const response = await api.post("/UbigeoView/AddUpdatePais", dto);
    return response.data.data;
};

export const addUpdateDepartamento = async (dto) => {
    const response = await api.post("/UbigeoView/AddUpdateDepartamento", dto);
    return response.data.data;
};

export const addUpdateProvincia = async (dto) => {
    const response = await api.post("/UbigeoView/AddUpdateProvincia", dto);
    return response.data.data;
};

export const addUpdateUbigeo = async (dto) => {
    const response = await api.post("/UbigeoView/AddUpdateUbigeo", dto);
    return response.data.data;
};

export const deletePais = async (id) => {
    const response = await api.delete("/UbigeoView/DeletePais?id=" + id);
    return response.data.data;
};

export const deleteDepartamento = async (id) => {
    const response = await api.delete("/UbigeoView/DeleteDepartamento?id=" + id);
    return response.data.data;
};

export const deleteProvincia = async (id) => {
    const response = await api.delete("/UbigeoView/DeleteProvincia?id=" + id);
    return response.data.data;
};

export const deleteUbigeo = async (id) => {
    const response = await api.delete("/UbigeoView/DeleteUbigeo?id=" + id);
    return response.data.data;
};
